import axios from 'axios';

const BASE_URL = 'https://nsocial.norissolutions.in/api';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('msocial_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('msocial_token');
      localStorage.removeItem('msocial_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/auth?action=register', data),
  login:    (data) => api.post('/auth?action=login',    data),
  me:       ()     => api.get('/auth?action=me'),
  logout:   ()     => api.post('/auth?action=logout'),
};

// ─── Posts ───────────────────────────────────────────────
export const postsAPI = {
  getFeed:      (page = 1)    => api.get(`/posts?action=feed&page=${page}`),
  getExplore:   (page = 1)    => api.get(`/posts?action=explore&page=${page}`),
  getUserPosts: (userId)      => api.get(`/posts?action=user&id=${userId}`),
  createPost:   (formData)    => api.post('/posts?action=create', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletePost:   (id)          => api.delete(`/posts?action=delete&id=${id}`),
  likePost:     (id)          => api.post(`/posts?action=like&id=${id}`),
  savePost:     (id)          => api.post(`/posts?action=save&id=${id}`),
  getComments:  (id)          => api.get(`/posts?action=comments&id=${id}`),
  addComment:   (id, content) => api.post(`/posts?action=comment&id=${id}`, { content }),
};

// ─── Users ───────────────────────────────────────────────
export const usersAPI = {
  getProfile:       (id)    => api.get(`/users?action=profile&id=${id}`),
  updateProfile:    (data)  => api.put('/users?action=update', data),
  uploadAvatar:     (form)  => api.post('/users?action=avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } }),
  toggleFollow:     (id)    => api.post(`/users?action=follow&id=${id}`),
  getFollowers:     (id)    => api.get(`/users?action=followers&id=${id}`),
  getFollowing:     (id)    => api.get(`/users?action=following&id=${id}`),
  searchUsers:      (q)     => api.get(`/users?action=search&q=${encodeURIComponent(q)}`),
  getSuggestions:   ()      => api.get('/users?action=suggestions'),
  getNotifications: ()      => api.get('/users?action=notifications'),
};

// ─── Stories ─────────────────────────────────────────────
export const storiesAPI = {
  getFeed:     ()          => api.get('/stories?action=feed'),
  createStory: (formData)  => api.post('/stories?action=create', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  viewStory:   (id)        => api.post(`/stories?action=view&id=${id}`),
  deleteStory: (id)        => api.delete(`/stories?action=delete&id=${id}`),
};

// ─── Messages ────────────────────────────────────────────
export const messagesAPI = {
  getConversations: ()          => api.get('/messages?action=conversations'),
  getThread:        (userId)    => api.get(`/messages?action=thread&id=${userId}`),
  sendMessage:      (id, content) => api.post(`/messages?action=send&id=${id}`, { content }),
};

export default api;
